import {useEffect, useState} from "react";
import ImageUtils from "../../utils/ImageUtils";
import organisations_api from "../../api/protected/organisations";
import GenericDialog from "../GenericDialog";
import sect_api from "../../api/sectors";
import {useNavigate} from "react-router-dom";
import tick from "../../assets/tasks-tick.svg";


const OrganisationForm = (props) => {

    const navigate = useNavigate();

    const [organisationName, setOrganisationName] = useState("");
    const [organisationDescription, setOrganisationDescription] = useState("");
    const [organisationSector, setOrganisationSector] = useState(0)
    const [organisationLogo, setOrganisationLogo] = useState()
    const [organisationLogoBase64, setOrganisationLogoBase64] = useState("")
    const [organisationLogoFileType, setOrganisationLogoFileType] = useState("")
    const [organisationID, setOrganisationID] = useState()
    const [editor, setEditor] = useState(false)
    const [sectors, setSectors] = useState([])
    const [error, setError] = useState('');
    const buttons = [{"text":"OK", "id": "1"}];
    const [buttonText, setButtonText] = useState("")
    const updateData = props.updateData

    const [showNameWarning, setShowNameWarning] = useState(false)
    const [showSectorWarning, setShowSectorWarning] = useState(false)
    const [showUpdateState, setShowUpdateState] = useState(false)
    const [updateStateText, setUpdateStateText] = useState("")
    const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false)
    const subscriptionPopupButtons = [{"text":"OK", "id": "1"}, {"text":"Upgrade", "id": "2"}];

    const [disclaimer, setDisclaimer] = useState(false)

    useEffect(() => {
        setShowSectorWarning(!organisationSector || organisationSector === 0)
    }, [organisationSector])

    useEffect(() => {
        setShowNameWarning(!organisationName || organisationName === "")
    }, [organisationName])

    useEffect(() => {
        if (!props.buttonText) return;
        setButtonText(props.buttonText)
    }, [props.buttonText])

    useEffect(() => {
        if (!props.organisationName) return;
        setOrganisationName(props.organisationName)
    }, [props.organisationName]);

    useEffect(() => {
        if (!props.organisationDescription) return;
        setOrganisationDescription(props.organisationDescription)
    }, [props.organisationDescription]);

    useEffect(() => {
        if (!props.organisationLogo) return;
        setOrganisationLogo(props.organisationLogo)
    }, [props.organisationLogo]);

    useEffect(() => {
        if (!props.organisationID) return;
        setOrganisationID(props.organisationID)
    }, [props.organisationID]);

    useEffect(() => {
        if (!props.organisationSector) {
            setShowSectorWarning(true);
            return;
        }
        setOrganisationSector(props.organisationSector)
        setShowSectorWarning(false)
    }, [props.organisationSector])

    useEffect(() => {
        if (!props.organisationSector) {
            setShowNameWarning(true);
            return;
        }
        setShowNameWarning(props.organisationSector)
        setShowNameWarning(false)
    }, [props.organisationSector])

    useEffect(() => {
        if(!props.editor) return;
        setEditor(props.editor)
    }, [props.editor])

    useEffect(() => {
        getSectors()
    }, []);


    const formSubmit = (ev) => {
        ev.preventDefault();
        if (!organisationID) NewOrganisation()
        else EditOrganisation()
    }

    const EditOrganisation = () => {
        if (!organisationID) return;
        let body = {
            "name": organisationName,
            "description": organisationDescription,
            "sector": organisationSector
        }
        let response = organisations_api.updateOrganisation(organisationID, body);
        response.then(() => {
            handleOrganisationLogoUpdate(organisationID)
        }).catch(() => {
            setUpdateStateText("Failed to update organisation details.")
            setShowUpdateState(true)
        }).finally(() => {
            setUpdateStateText("Organisation details updated successfully.")
            setShowUpdateState(true)
        });
    }

    const NewOrganisation = ()=> {
        if (!disclaimer) return;
        let body = {
            "name": organisationName,
            "description": organisationDescription,
            "sector": organisationSector,
        }
        let response = organisations_api.newOrganisation(body);
        response.then(response => {
            if (organisationLogoBase64 !== "") {
                handleOrganisationLogoUpdate(response.data.organisation_id)
            } else {
                updateData()
            }
        }).catch(err => {
            if (err.response.request.status === 402) setShowSubscriptionPopup(true);
            console.log(err)
        })
    }

    const getSectors = () => {
        let response = sect_api.getSectors();
        response.then(response => {
            let _sectors = response.data.sectors
            let _initial = [{"id": 0, "name":""}]
            _sectors.forEach((element) => {
                let _sector = {"id":element.id, "name":element.name}
                _initial.push(_sector)
            });
            setSectors(_initial);
        }).catch(err => console.log(err))
    }

    const updateOrganisationLogoFileType = (string) => {
        if (string === "" || string === undefined) return;
        setOrganisationLogoFileType(string)
    }

    const handleOrganisationLogoUpdate = (organisation_id) => {
        if (!organisationLogoBase64 || !organisationLogoFileType || !organisation_id) {
            updateData()
            return;
        }
        let body = {
            "file_format": organisationLogoFileType,
            "image_string": organisationLogoBase64.split(',')[1],
            "organisation_id": organisation_id
        }
        let response = organisations_api.updateOrganisationLogo(body);
        response.then(() => updateData()).catch(() => {
            setError("Failed to update the organisation. Please ensure any image uploaded is a recognized format " +
                "and is not too large");
        })
    }

    const handleOrganisationImageClick = () => {
        let element = document.getElementById("organisation-logo-uploader")
        if (!element) return;
        element.click()
    }

    const handleErrorDialogResult = (res) => {
        if(!res) return;
        setError("")
        if (organisationID === undefined) {
            updateData()
            navigate("/organisations")
        }
    }

    const handleSubscriptionPopupResult = (res) => {
        if(!res) return;
        if (res === "1") {
            window.location.reload();
        } else {
            navigate("/pricing-plans")
        }
    }

    const handleSuccessButton = (res) => {
        if(!res) return;
        setShowUpdateState(false)
        setUpdateStateText("")
    }

    const handleDragOver = (ev) => {
        ev.preventDefault()
    }

    const handleDrop = async (ev) => {
        ev.preventDefault()
        if (!editor && organisationID) return;
        let _files = ev.dataTransfer.files
        if (_files[0].size <= 64000000) {
            if (_files[0].type.split("/")[0] === "image") {
                let base64_link = await ImageUtils.convertBase64(_files[0]);
                setOrganisationLogoBase64(base64_link)
                updateOrganisationLogoFileType(_files[0].name.split(".")[1])
            }
        }
    }

    return (
        <div className="organisation-form-container">
            <div className="organisation-form-title">Organisation Details</div>
            <form name="organisation-form" method="POST">
                <div className="field-input">
                    <div className="label">Organisation Name</div>
                    <div className="field-input-entry">
                        <input className="organisation-name-input" name="organisation.name" type="text" value={organisationName}
                               onChange={ev => setOrganisationName(ev.target.value)}
                               required disabled={organisationID && !editor}
                        />
                    </div>
                    {showNameWarning && !props.organisationDemo ?
                        <div className="messages organisation-form">This is a required field.</div>
                        : null
                    }
                </div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label">Organisation Description</div>
                        <input name="organisation.description" type="text" maxLength="50" value={organisationDescription}
                               onChange={(ev) => {
                                   if (ev.target.value.length <= 50)
                                       setOrganisationDescription(ev.target.value)
                               }}
                               disabled={organisationID && !editor} placeholder="Short description for your reference only - max 50 characters"
                        />
                    </div>
                </div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label">Organisation Business/Industry Sector</div>
                        <select name="organisation.sector" value={organisationSector} required
                                onChange={ev => setOrganisationSector(ev.target.value)}
                                disabled={organisationID && !editor}>
                            {sectors && sectors.map((sector) => {
                                return <option value={sector.id}>{sector.name}</option>
                            })}
                        </select>
                        {showSectorWarning && !props.organisationDemo ?
                            <div className="messages organisation-form">This is a required field.</div>
                            : null
                        }
                    </div>
                </div>
                <div className="field-input">
                    <div className="label">Organisation Logo</div>
                    <div className="field-input-entry">
                        <div className="settings-image-container">
                            {organisationLogoBase64 && organisationLogoBase64 ?
                                <img src={organisationLogoBase64} className="settings-image" alt="Profile Picture"/>
                                : organisationLogo && organisationLogo ?
                                    <img src={organisationLogo} className="settings-image" alt="Profile Picture"/>
                                    : null
                            }
                        </div>
                        <input accept="image/*" type='file' id="organisation-logo-uploader"
                               onChange={async (e) => {
                                   let base64_image = await ImageUtils.convertBase64(e.target.files[0]);
                                   setOrganisationLogoBase64(base64_image);
                                   updateOrganisationLogoFileType(e.target.files[0].name.split(".")[1]);
                               }}
                               className="organisation-logo-uploader-hidden" disabled={organisationID && !editor}
                        />
                    </div>
                </div>
                <div className="field-input">
                    <div className="logo-uploader-container link" onClick={() => handleOrganisationImageClick()}
                         onDragOver={handleDragOver} onDrop={handleDrop}>
                        Drag & Drop or Click to select files
                    </div>
                </div>
                {!organisationID ?
                    <div className="organisation-disclaimer-container">
                        <div className="organisation-disclaimer-checkbox-container">
                            <div className={`tasks-radio-button grey ${disclaimer ? "checked" : ""}`}
                                 onClick={() => setDisclaimer(!disclaimer)}>
                                <img src={tick} alt="Checked"/>
                            </div>
                        </div>
                        <div className="tasks-radio-text">
                            I confirm that I have appropriate permission to upload the personal details
                            (name & email address) for all those individuals who are going to be invited to complete
                            the team coaching diagnostic survey and that they have all received prior notification
                            as to the purpose of doing so. {'\n'}
                            <div className="tasks-radio-text">
                                Note: Appropriate permission would usually be granted by the HR function to a Team Coach
                                as part of a contracted Team Coaching engagement or by the HR function for internal use
                                within its teams of employees.
                            </div>
                        </div>
                    </div>
                    :null}
                {!organisationID || (organisationID && editor) ?
                    <div className="field-input">
                        <button className="update-organisation-button link" name="method" type="submit" value="password"
                                disabled={!organisationName || !organisationSector}
                                onClick={formSubmit}>
                            {buttonText && buttonText}
                        </button>
                    </div>
                    : null
                }
            </form>
            {error && error ?
                <GenericDialog title="Update Error" text={error} buttons={buttons}
                               result={handleErrorDialogResult.bind(this)}/>
                : null
            }
            {showUpdateState ?
                <GenericDialog title="Organisation Update" text={updateStateText} buttons={buttons}
                               result={handleSuccessButton.bind(this)}/>
                : null
            }
            {showSubscriptionPopup ?
                <GenericDialog title="Maximum organisations reached"
                               text="You have reached the maximum organisations for your subscription tier. Please upgrade if you wish to add more"
                               buttons={subscriptionPopupButtons}
                               result={handleSubscriptionPopupResult.bind(this)}/>
                : null
            }
        </div>
    )
}


export default OrganisationForm